import { Link } from "react-router-dom";
import { Clock3 } from "lucide-react";
import { TopBar } from "../TopBar";
import { SignOutButton } from "../AccountMenu";

const STATUS_STYLES = {
  pending: "bg-[#F5E6BA] text-[#7A0016]",
  approved: "bg-emerald-50 text-emerald-800",
  rejected: "bg-red-50 text-red-800",
  hold: "bg-amber-50 text-amber-800",
  blocked: "bg-red-100 text-red-900",
  inactive: "bg-stone-100 text-stone-700",
  verified: "bg-emerald-50 text-emerald-800",
};

export const StatusBadge = ({ status }) => (
  <span data-testid="profile-status-badge" className={`rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wider ${STATUS_STYLES[status] || STATUS_STYLES.pending}`}>
    {status}
  </span>
);

export function UnderReview({ profile }) {
  return (
    <div className="rmm-bg min-h-screen">
      <TopBar right={<SignOutButton />} />
      <main className="mx-auto max-w-xl px-4 py-12 sm:px-6">
        <section data-testid="under-review-status-card" className="rmm-card rmm-rise p-8 text-center sm:p-10">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border-2 border-[#D4AF37] bg-[#7A0016]">
            <Clock3 className="h-7 w-7 text-[#F5E6BA]" />
          </span>
          <h1 className="mt-5 font-display text-3xl font-bold text-[#4A000E] sm:text-4xl">Your profile is under review.</h1>
          <p className="mt-3 text-sm text-[#8C6A6C]">Our team will verify your details and photos. You will be notified once your profile is approved.</p>
          <div className="mt-6 flex flex-col items-center gap-3">
            <StatusBadge status={profile.status} />
            {profile.registration_no && (
              <p data-testid="registration-number" className="text-sm text-[#2C2424]">
                Registration no. <strong className="font-display text-xl text-[#7A0016]">{profile.registration_no}</strong>
              </p>
            )}
          </div>
          <div className="gold-rule my-7" />
          <Link to="/portal" data-testid="go-to-portal-link" className="inline-flex h-11 items-center rounded-full bg-[#7A0016] px-6 text-sm font-semibold text-[#F5E6BA] transition-colors hover:bg-[#4A000E]">
            Go to my portal
          </Link>
        </section>
      </main>
    </div>
  );
}
